import React from "react";
import { cn } from "../../../../helpers/cn";

type ActionsWrapperProps = React.ComponentProps<"div">;

export const ActionsWrapper = ({
  className,
  children,
}: ActionsWrapperProps) => {
  return <div className={cn("flex space-x-[12px]", className)}>{children}</div>;
};
